export default {
      id: "simple-play-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#simple-play-usage",
      toString: function () {
        return this.url;
      }
    }